import { useLocalParticipant } from '@livekit/components-react'
import { Button } from '@/components/ui/button'
import { MicIcon, MicOffIcon } from './icons'

export function AudioToggle() {
  const { localParticipant } = useLocalParticipant()

  const isMicEnabled = localParticipant.isMicrophoneEnabled

  const toggleMicrophone = async () => {
    await localParticipant.setMicrophoneEnabled(!isMicEnabled)
  }

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleMicrophone}
      className={
        isMicEnabled
          ? 'bg-background hover:bg-muted'
          : 'bg-muted text-muted-foreground hover:bg-muted/90'
      }
    >
      {isMicEnabled ? (
        <MicIcon className="h-4 w-4" />
      ) : (
        <MicOffIcon className="h-4 w-4" />
      )}
    </Button>
  )
}
